<template>
  <section>
    <button type="button" class="button is-fullwidth my-1" style="justify-content:flex-start" @click="isExpanded = !isExpanded">
      <span class="icon"><i class="far fa-calendar"></i></span>
      <span>{{ meetingDate }}</span>
      <span class="icon" v-show="!isExpanded"><i class="fas fa-angle-down"></i></span>
      <span class="icon" v-show="isExpanded"><i class="fas fa-angle-up"></i></span>
    </button>
    <ul v-show="isExpanded">
      <li v-for="(timeslot, timeslotIdx) in slots" :key="timeslotIdx" v-if="timeslot.is_open && isTimeslotOpen(timeslot.id, userSchedule)">
        <label class="radio">
          <input type="radio" v-model="rescheduleData.newRequestSlotId" name="newRequestSlotId" :value="timeslot.id">
          {{ `${timeslot.start_time} - ${timeslot.end_time}` }}
        </label>
      </li>
    </ul>
  </section>
</template>

<script>
import { isTimeslotOpen } from '@/services/utils'

export default {
  props: ['rescheduleData', 'slots', 'meetingDate', 'userSchedule'],

  data() {
    return {
      isExpanded: false
    }
  },
  methods: {
    isTimeslotOpen
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/RescheduleSlots.vue